import { statusActions } from "./Action";
import { AuthActions } from "../LoginRedux/Action";

const initialState = {
  isOnline: false,
  deskNumber: null,
};

export const statusReducer = (state = initialState, action) => {
  switch (action.type) {
    case statusActions.USER_ONLINE:
      return {
        ...state,
        isOnline: action.payload,
      };

    case statusActions.GET_DESK_NUMBER:
      return {
        ...state,
        deskNumber: action.payload,
      };

    case AuthActions.Logout_User:
      return {
        isOnline: false,
        deskNumber: null,
      };

    default:
      return state;
  }
};
